import {RESOLUTION_CHANGE} from '../constants.js';
import Operation from './Operation.js';

class ResizeResolutionChange extends Operation {
    constructor(sequenceRollEvent, resolutionChangeEvent, difference) {
        super(undefined, RESOLUTION_CHANGE);
        this.sequenceRollEvent = sequenceRollEvent;
        this.event = resolutionChangeEvent;
        this.difference = difference;
    }

    get events() {
        return this.sequenceRollEvent.events;
    }

    set events(e) {
        this.sequenceRollEvent.events = e;
    }

    execute() {
        let toDelete = undefined;
        for (let i=0; i < this.events.length; i++) {
            let eventToChange = this.events[i];
            if (eventToChange.step > this.event.step) {
                eventToChange.step += this.difference;

                let nextEvent = this.events[i+1];
                if (nextEvent && (nextEvent.step <= eventToChange.step)) {
                    toDelete = i;
                }

                if (eventToChange.duration + this.difference < 0) {
                    toDelete = i;
                }
                break;
            }
        }

        if (toDelete !== undefined) {
            this.sequenceRollEvent.subEvents.splice(toDelete - 1, 1);
        }

        this.sequenceRollEvent.calculateDurations();
    }
}

export default ResizeResolutionChange;
